import { DASHBOARD_SETTINGS_LINK } from '@components/Router/constants'
import type { ID } from '@octopus-do/octopus-project-core'
import { Cog } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import { SidebarLink } from '../SidebarLink'

interface Props {
  id: ID
}

export const SettingsLink: React.FC<Props> = ({ id }) => (
  <SidebarLink
    to={`${DASHBOARD_SETTINGS_LINK}/${id}`}
    label="Team settings"
    icon={Cog}
  />
)
